<p>master-data-editor works!</p>
<div class="form">
    <div class="grid">
        <div class="row">
            <div class="col-lg-3 col-sm-12 col-xs-12">

                <div class="input-group input-group-sm  mb-2">
                    <div class="input-group-prepend">
                        <div class="input-group-text">Name</div>
                    </div>
                    <input [(ngModel)]="name" type="text" class="form-control" placeholder="Enter name here">
                </div>
            </div>
            <div class="col-3">

                <div class="input-group input-group-sm  mb-2">
                    <div class="input-group-prepend">
                        <div class="input-group-text">Display Text</div>
                    </div>
                    <input [(ngModel)]="displayText" type="text" class="form-control"
                        placeholder="Enter display text here">
                </div>
            </div>

            <div class="col-4">

                <div class="input-group input-group-sm  mb-2">
                    <div class="input-group-prepend">
                        <div class="input-group-text">Master Data Type</div>
                    </div>
                    <select [(ngModel)]="masterDataType" class="form-select">

                        <option *ngFor="let item of masterDataTypes" [ngValue]="item">{{item.name}}</option>

                    </select>
                </div>
            </div>
            <div class="col-1">
                <div class="d-grid">
                    <button type="button" class="btn btn-primary btn-block" (click)="onSave()">Save</button>
                </div>
            </div>
        </div>

    </div>
</div>